import {
  RectangleGroupIcon,
  PuzzlePieceIcon,
  BuildingOffice2Icon,
  SquaresPlusIcon,
  BriefcaseIcon,
  AcademicCapIcon,
  WindowIcon,
  ChatBubbleLeftEllipsisIcon,
  NewspaperIcon,
  MicrophoneIcon,
  UserGroupIcon,
  ComputerDesktopIcon,
} from '@heroicons/react/24/outline'

export const navListMenuItems: Record<
  string,
  {
    title: string
    description: string
    icon: React.ForwardRefExoticComponent<
      Omit<React.SVGProps<SVGSVGElement>, 'ref'> & {
        title?: string | undefined
        titleId?: string | undefined
      } & React.RefAttributes<SVGSVGElement>
    >
    link: string
    isExternal?: boolean
    isDisabled?: boolean
  }[]
> = {
  firm: [
    {
      title: 'Créez votre profil employeur',
      description: 'Attirez plus de candidats avec votre marque employeur',
      icon: WindowIcon,
      link: '/je-suis-un-cabinet',
      isExternal: false,
    },
    {
      title: "Déposez vos offres d'emploi",
      description: "Partagez vos offres d'emploi avec les candidats",
      icon: SquaresPlusIcon,
      link: '/je-suis-un-cabinet',
      isExternal: false,
    },
    {
      title: 'Gérez vos recrutements',
      description:
        'Suivez de vos recrutements et répondez en clic aux candidatures',
      icon: RectangleGroupIcon,
      link: '/je-suis-un-cabinet',
      isExternal: false,
    },
    {
      title: 'Témoignages',
      description: 'Nos clients partagent leur expérience',
      icon: ChatBubbleLeftEllipsisIcon,
      link: 'https://www.youtube.com/playlist?list=PLALmj_-UZb0TOUiWoycIZ0j82ibDOvHT7',
      isExternal: true,
    },
  ],
  candidate: [
    {
      title: "Offres d'emploi",
      description: 'Découvre toutes les opportunités en cabinet',
      icon: BriefcaseIcon,
      link: '/offres',
    },
    {
      title: 'Cabinets',
      description:
        'Projette-toi et découvre toutes les opportunités en cabinet',
      icon: BuildingOffice2Icon,
      link: '/cabinets',
    },
    {
      title: 'Matching',
      description:
        "Crée ton profil et reçoit des propositions d'emploi en cabinet",
      icon: PuzzlePieceIcon,
      link: 'https://lamadash.fr/signup_login_candidat',
      isExternal: true,
    },
    {
      title: 'Organismes de formation',
      description: 'Trouve ta prochaine formation',
      icon: AcademicCapIcon,
      link: 'https://lamacompta-ecoles.softr.app/',
      isExternal: true,
    },
  ],
  ressources: [
    {
      title: 'Nos articles',
      description: 'On te partage toutes les actus et nos tips',
      icon: NewspaperIcon,
      link: 'https://ressources.lamacompta.co',
      isExternal: true,
    },
    {
      title: "Podcast 'Génération Comptable'",
      description:
        'Pars à la découverte des meilleures pratiques en cabinet avec Judie',
      icon: MicrophoneIcon,
      link: '/podcast/generation-comptable',
      isExternal: false,
    },
    {
      title: 'Groupements de cabinets',
      description: 'Découvre les groupements de cabinets comptables',
      icon: UserGroupIcon,
      link: '/cabinets/groupements',
    },
    {
      title: 'Choisis tes logiciels',
      description: 'Découvre les logiciels les plus utilisés en cabinet',
      icon: ComputerDesktopIcon,
      link: '/outils',
    },
  ],
}
